import type { BillingPlatformFeeCouponEntity, BillingPlatformFeePlanEntity } from './entity_types/Billing';
import { hFetch } from './hFetch';

export type ListResponse<T> = {
  records: T[];
  status: 'success' | 'error';
  message?: string;
};

export type DetailResponse<T> = {
  record: T;
  status: 'success' | 'error';
  message?: string;
};

export const listPlatformFeePlans = async () => {
  return await hFetch<ListResponse<BillingPlatformFeePlanEntity>>({ url: '/api/billing/platform_fee_plans' });
};

export const listPlatformFeeCoupons = async () => {
  return await hFetch<ListResponse<BillingPlatformFeeCouponEntity>>({ url: '/api/billing/platform_fee_coupons' });
};

export const getPlatformFeePlan = async (id: string) => {
  return await hFetch<DetailResponse<BillingPlatformFeePlanEntity>>({ url: `/api/billing/platform_fee_plans/${id}` });
};

export const getPlatformFeeCoupon = async (id: string) => {
  return await hFetch<DetailResponse<BillingPlatformFeeCouponEntity>>({
    url: `/api/billing/platform_fee_coupons/${id}`,
  });
};
